import { render, staticRenderFns } from "./EnergyCanvas.vue?vue&type=template&id=51c88257&"
import script from "./EnergyCanvas.vue?vue&type=script&lang=js&"
export * from "./EnergyCanvas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports